import React from 'react';
import { MdArrowBack } from 'react-icons/md';
import { useAppNavigate } from '../hooks/useAppNavigate';

export interface BackButtonProps {
  text: string;
  onClick?: () => void;
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ 
  text, 
  onClick, 
  className = "" 
}) => {
  const appNavigate = useAppNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      // Navigate to home page with mode-aware navigation
      appNavigate('/');
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`inline-flex items-center transition-colors mb-4 ${className}`}
      style={{ color: '#EF4444' }}
      onMouseEnter={(e) => e.currentTarget.style.color = '#DC2626'}
      onMouseLeave={(e) => e.currentTarget.style.color = '#EF4444'}
    >
      <MdArrowBack className="h-4 w-4 mr-2" /> {text}
    </button>
  );
};

export default BackButton;
